import { fn } from 'storybook/test';
import { BrowserRouter } from 'react-router';

import type { Meta, StoryFn } from '@storybook/react';
import type { LinkButtonProps } from './LinkButton';

import { LinkButton } from './LinkButton';

const codeString = `
// Has all HTMLAnchorElement props available except "className" and "style" 
 <LinkButton variant={variant} to={to} replace={replace} buttonRef={buttonRef}>{children}</LinkButton>
`;

// eslint-disable-next-line import/no-default-export
export default {
  title: 'Atoms/Buttons/LinkButton',
  component: LinkButton,
  argTypes: {
    variant: {
      options: [
        'primary',
        'secondary',
        'destructive-primary',
        'destructive-secondary',
        'blank',
        'blank-subtle',
        'blank-icon',
      ],
      control: { type: 'radio' },
    },
  },
  parameters: {
    inspectComponent: LinkButton,
    codeString: codeString,
  },
} as Meta<LinkButtonProps>;

const Template: StoryFn<LinkButtonProps> = (args) => (
  <BrowserRouter>
    <LinkButton {...args} />
  </BrowserRouter>
);

const defaultArgs: Partial<LinkButtonProps> = {
  variant: 'primary',
  onClick: fn(),
};

export const LinkButtonExample = Template.bind({});
LinkButtonExample.args = {
  children: 'Click me!',
  ...defaultArgs,
};

export const WithMultipleChildren = Template.bind({});
WithMultipleChildren.args = {
  ...defaultArgs,
  children: (
    <>
      <div>Child 1</div>
      <div>Child 2</div>
    </>
  ),
};

WithMultipleChildren.argTypes = {
  ...WithMultipleChildren.argTypes,
  children: {
    table: {
      disable: true, // Disable children controls for this specific story
    },
  },
};
